/** Colores del semáforo. Una fila EJEMPLO nunca usa rojo. */

const TONO = {
  en_rango: "bg-emerald-100 text-emerald-900",
  alto: "bg-amber-100 text-amber-950",
  muy_alto: "bg-red-100 text-red-900",
  bajo: "bg-sky-100 text-sky-900",
  sin_referencia: "bg-slate-100 text-slate-600",
  ejemplo: "bg-amber-100 text-amber-950",
  base: "bg-slate-100 text-slate-800",
};

export function claseSemaforo(row) {
  if (row?.es_ejemplo && (row.estado === "ejemplo" || row.estado === "muy_alto")) {
    return TONO.ejemplo;
  }
  if (row?.estado === "muy_alto" && row?.pintar_rojo) return TONO.muy_alto;
  return TONO[row?.estado] || TONO.sin_referencia;
}

export function moneyMx(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n);
}

export function pctMx(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`;
}
